
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platforms/[slug]/how-to-add",
      function () {
        return require("private-next-pages/platforms/[slug]/how-to-add.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platforms/[slug]/how-to-add"])
      });
    }
  